/**
 * ============================================================================
 * СЕРВИС DASHBOARD
 * ============================================================================
 */

import apiClient from './api'

/**
 * Получение статистики для админ-панели
 * apiClient interceptor уже возвращает response.data
 */
export const getDashboardStats = async () => {
	return await apiClient.get('/dashboard/stats')
}

/**
 * Получение последних действий
 * @param {Object} params - { limit, offset, all }
 */
export const getRecentActions = async (params = {}) => {
	return await apiClient.get('/dashboard/actions', { params })
}

/**
 * Получение данных для графика активности
 * @param {Object} params - { period: 'year' | 'month' | 'week' }
 */
export const getActivityChart = async (params = {}) => {
	return await apiClient.get('/dashboard/activity-chart', { params })
}

/**
 * Расширенная аналитика платформы
 * @param {Object} params - { period: '7d' | '30d' | '90d' | '12m', segment: 'all' | 'new' | 'paid' | 'b2b' }
 */
export const getAnalyticsOverview = async (params = {}) => {
	return await apiClient.get('/dashboard/analytics', { params })
}

/**
 * Экспорт аналитики
 * @param {Object} params - { format: 'json' | 'csv', type: 'stats' | 'users' | 'courses' | 'all' }
 */
export const exportAnalytics = async (params = {}) => {
	return await apiClient.get('/dashboard/export', {
		params,
		responseType: 'blob',
	})
}

export default {
	getDashboardStats,
	getRecentActions,
	getActivityChart,
	getAnalyticsOverview,
	exportAnalytics,
}
